"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useOnBackPress = (control, events, listenerBackHandler) => {
    (0, react_1.useEffect)(() => {
        if (!listenerBackHandler) {
            return undefined;
        }
        const listener = () => {
            if (events && events.onBackPress) {
                events.onBackPress();
                return false;
            }
            return true;
        };
        const { remove } = listenerBackHandler('hardwareBackPress', listener);
        return () => {
            remove();
        };
    }, [control.id, events, listenerBackHandler]);
};
exports.default = useOnBackPress;
